<template>
  <NuxtLayout name="default">
    <template #menu>
      <TitleMenu table="texts" />
    </template>
    <slot />
  </NuxtLayout>
</template>
